export default __webpack_public_path__ + "static/media/twitter.c1262a03.png";